export const updateCrumbs = ({ commit, state }, to) => {
  const name = to.name
  const res = []

  if (name == 'ProjectList') {
    res.push(crumb0())
  }

  if (name == 'ProjectOverview') {
    res.push(crumb0())
    res.push(crumb1())
  }

  if (name == 'BuildingOverview') {
    res.push(crumb0())
    res.push(crumb1())
    res.push(crumb2(state))
  }

  if (name == 'FloorOverview') {
    res.push(crumb0())
    res.push(crumb1())
    res.push(crumb2(state))
    res.push(crumb3(state))
  }

  if (name == 'ZoneOverview') {
    res.push(crumb0())
    res.push(crumb1())
    res.push(crumb2(state))
    res.push(crumb3(state))
    res.push(crumb4(state))
  }

  commit('UPDATE_CRUMBS', res)
}

const crumb0 = () => {
  return { title: 'Home', to: '/' }
}
const crumb1 = () => {
  return { title: 'Projectenlijst', to: '/projectlist' }
}
const crumb2 = state => {
  if (state.project != null)
    return {
      title: state.project.selectedProject.name,
      to: `/projectoverview/${state.project.selectedProject.projectId}`
    }
  return { title: '', to: '' }
}
const crumb3 = state => {
  if (state.project.selectedBuilding != null)
    return {
      title: state.project.selectedBuilding.name,
      to: `/buildingoverview/${state.project.selectedProject.projectId}/${state.project.selectedBuilding.buildingId}`
    }
  return { title: '', to: '' }
}
const crumb4 = state => {
  if (state.project.selectedFloor != null)
    return {
      title: state.project.selectedFloor.name,
      to: `/flooroverview/${state.project.selectedProject.projectId}/${state.project.selectedBuilding.buildingId}/${state.project.selectedFloor.storyId}`
    }
  return { title: '', to: '' }
}



// WEBPACK FOOTER //
// ./src/store/actions.js